import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es/translation.json";
import en from "./locales/en/translation.json";

const saved = localStorage.getItem("lang");
const browser = (navigator.language || "es").slice(0, 2);
const startLng = saved || (browser === "es" ? "es" : "en");

i18n.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en } },
  lng: startLng,
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

// mantener <html lang="...">
document.documentElement.lang = startLng;

export default i18n;
